import React, { useCallback, useMemo } from 'react';
import CheckboxField from 'components/CheckboxFieldGroup/CheckboxField';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_MEDIUM } from 'models/Notification';

export function useRfi() {
  const { t } = useTranslation();

  const notificationMediumOptions = useMemo(
    () => [
      {
        label: t('email'),
        value: NOTIFICATION_MEDIUM.EMAIL,
      },
      {
        label: t('sms'),
        value: NOTIFICATION_MEDIUM.SMS,
      },
      {
        label: t('platformNotifications'),
        value: NOTIFICATION_MEDIUM.PLATFORM,
      },
    ],
    [t],
  );

  const dueDateReminderOptions = useMemo(
    () => [
      {
        name: 'atDeadlineReminder',
        label: t('atDeadline'),
      },
      {
        name: 'twentyFourHoursBeforeDeadlineReminder',
        label: t('24hoursBeforeDeadline'),
      },
      {
        name: 'threeDaysAfterDeadlineReminder',
        label: t('3daysAfterDeadline'),
      },
      {
        name: 'fiveDaysAfterDeadlineReminder',
        label: t('5daysAfterDeadline'),
      },
    ],
    [t],
  );

  const getDueDateReminderOptions = useCallback(
    (disabled = false) =>
      dueDateReminderOptions.map(({ name, label }) => (
        <Field
          key={name}
          name={name}
          label={label}
          component={CheckboxField}
          type="checkbox"
          disabled={disabled}
        />
      )),
    [dueDateReminderOptions],
  );

  return {
    notificationMediumOptions,
    getDueDateReminderOptions,
  };
}
